import { Text } from "@mantine/core";

import type { QualityEfficiencyMetricsView } from "../data/types";

import qualityEfficiencyIcon from "./assets/qualityEfficiencyIcon.png";
import sharedStyles from "./cardContent.module.css";
import { computeInverseRingFill } from "./computeRingFill";
import { MetricCard } from "./MetricCard";
import styles from "./qualityEfficiencyCard.module.css";
import { RingArt } from "./RingArt";
import { QUALITY_EFFICIENCY_GRADIENT, TRANSFER_RATE_CEILING_PERCENT, TRANSFER_RATE_TARGET_PERCENT } from "./targets";

interface Props {
    view: QualityEfficiencyMetricsView;
}

export function QualityEfficiencyCard({ view }: Props) {
    const transferRate = view.transferRatePercent;
    const hasRate = transferRate !== null;

    const ringProgress = computeInverseRingFill(transferRate, TRANSFER_RATE_TARGET_PERCENT, {
        ceiling: TRANSFER_RATE_CEILING_PERCENT,
    });

    return (
        <MetricCard
            title="Quality and efficiency"
            isLoading={view.isLoading}
            isEmpty={!hasRate}
            emptyValue="No transfers yesterday."
            art={
                <RingArt progress={ringProgress} gradient={QUALITY_EFFICIENCY_GRADIENT} isLoading={view.isLoading}>
                    <img src={qualityEfficiencyIcon} alt="" className={sharedStyles.icon} />
                </RingArt>
            }
            value={
                <>
                    <Text component="span" className={sharedStyles.bigNumber}>
                        {transferRate !== null ? Math.round(transferRate) : null}
                    </Text>
                    <Text component="span" className={styles.smallNumber}>
                        %
                    </Text>
                </>
            }
            footer={
                <>
                    Transfer rate target <strong>({TRANSFER_RATE_TARGET_PERCENT}%)</strong>
                </>
            }
        />
    );
}
